import WbsItemApi, { WbsItemBasic } from '../../../lib/functions/wbsItem'
import { createBasicByCodeCache } from './basicByCodeCache'

// WBS アイテムのコードから WbsItemBasic を引くキャッシュ。キャッシュ・重複排除・失敗の扱いは
// createBasicByCodeCache 側に集約している（ユーザーのチップも同じ仕組みで引くため）。
export const wbsItemBasicCache = createBasicByCodeCache<WbsItemBasic>(
  code => WbsItemApi.getBasicByCode(code),
  'wbs item basic'
)
